<div class="notification-item">
  <h3 class="title">{{ title() }}</h3>
  <p class="description">{{ description() }}</p>
  <span class="timestamp">{{ timestamp() }}</span>
</div>
